import React from 'react';
import { Link } from 'react-router-dom';

// Completá tus datos acá para que se reflejen en todo el documento:
const DATOS_EMPRESA = {
  cuit: '', 
  domicilioLegal: '',
  email: 'pascoloquesos@gmail.com'
};

const PoliticaDePrivacidad = () => {
  return (
    <div style={styles.container}>
      <div style={styles.contentBox}>
        
        {/* Encabezado */}
        <h1 style={styles.mainTitle}>POLÍTICA DE PRIVACIDAD</h1>
        <p style={styles.date}>Última actualización: 10 de Junio de 2026</p>
        
        <hr style={styles.divider} />

        <p style={styles.paragraph}>
          <strong>Páscolo</strong> (en adelante, "Páscolo", "nosotros" o "el Sitio"), titular del sitio web 
          <strong> pascolo.com.ar</strong>, se compromete a proteger la privacidad y los datos personales de sus usuarios y clientes.
        </p>

        {/* Sección 1 */}
        <h2 style={styles.sectionTitle}>1. RESPONSABLE DEL TRATAMIENTO</h2>
        <ul style={styles.list}>
          <li><strong>Titular:</strong> Páscolo</li>
          <li><strong>CUIT:</strong> {DATOS_EMPRESA.cuit}</li>
          <li><strong>Domicilio legal:</strong> {DATOS_EMPRESA.domicilioLegal}</li>
          <li><strong>Correo electrónico:</strong> <a href={`mailto:${DATOS_EMPRESA.email}`} style={styles.link}>{DATOS_EMPRESA.email}</a></li>
        </ul>

        {/* Sección 2 */}
        <h2 style={styles.sectionTitle}>2. DATOS PERSONALES RECOPILADOS</h2>
        <p style={styles.paragraph}>
          Al realizar una compra o registrarse en el Sitio, podremos recopilar los siguientes datos:
        </p>
        <ul style={styles.list}>
          <li>Nombre y apellido.</li>
          <li>DNI.</li>
          <li>CUIT (cuando corresponda).</li>
          <li>Dirección de correo electrónico.</li>
          <li>Número de WhatsApp o teléfono de contacto.</li>
          <li>Dirección declarada por el usuario.</li>
          <li>Información vinculada a los pedidos realizados.</li>
        </ul>

        {/* Sección 3 */}
        <h2 style={styles.sectionTitle}>3. FINALIDAD DEL TRATAMIENTO</h2>
        <p style={styles.paragraph}>Los datos personales son utilizados exclusivamente para:</p>
        <ul style={styles.list}>
          <li>Gestionar y procesar pedidos.</li>
          <li>Verificar la identidad del comprador cuando resulte necesario.</li>
          <li>Contactar al cliente respecto de su compra.</li>
          <li>Coordinar la entrega o retiro de productos.</li>
          <li>Cumplir obligaciones legales, fiscales y contables.</li>
          <li>Resolver consultas, reclamos o solicitudes de los usuarios.</li>
        </ul>

        {/* Sección 4 */}
        <h2 style={styles.sectionTitle}>4. MEDIOS DE PAGO</h2>
        <p style={styles.paragraph}>
          Los pagos son procesados a través de <strong>Mercado Pago</strong>.
        </p>
        <p style={styles.paragraph}>
          Páscolo no almacena, procesa ni tiene acceso a los datos completos de tarjetas de crédito, débito u otros medios de pago utilizados por el cliente. La información financiera es gestionada directamente por Mercado Pago conforme a sus propios términos y políticas de privacidad.
        </p>

        {/* Sección 5 */}
        <h2 style={styles.sectionTitle}>5. COMPARTICIÓN DE DATOS</h2>
        <p style={styles.paragraph}>Los datos personales podrán ser compartidos únicamente con:</p>
        <ul style={styles.list}>
          <li>Mercado Pago para el procesamiento de pagos.</li>
          <li>Proveedores tecnológicos necesarios para la operación del sitio.</li>
          <li>Autoridades competentes cuando exista obligación legal.</li>
        </ul>
        <p style={styles.paragraph}>No se venden ni comercializan datos personales de usuarios.</p>

        {/* Sección 6 */}
        <h2 style={styles.sectionTitle}>6. ALMACENAMIENTO Y SEGURIDAD</h2>
        <p style={styles.paragraph}>
          La información es almacenada utilizando servicios de infraestructura tecnológica provistos por <strong>Amazon Web Services (AWS)</strong>.
        </p>
        <p style={styles.paragraph}>
          Se implementan medidas técnicas y organizativas razonables destinadas a proteger la información contra accesos no autorizados, alteraciones, pérdidas o divulgaciones indebidas.
        </p>

        {/* Sección 7 */}
        <h2 style={styles.sectionTitle}>7. PLAZO DE CONSERVACIÓN</h2>
        <p style={styles.paragraph}>
          Los datos serán conservados durante el tiempo necesario para gestionar la relación comercial, cumplir obligaciones legales y atender posibles reclamos administrativos, fiscales o judiciales.
        </p>

        {/* Sección 8 */}
        <h2 style={styles.sectionTitle}>8. DERECHOS DE LOS TITULARES</h2>
        <p style={styles.paragraph}>Los usuarios podrán solicitar:</p>
        <ul style={styles.list}>
          <li>Acceso a sus datos personales.</li>
          <li>Rectificación de datos incorrectos o desactualizados.</li>
          <li>Supresión de datos cuando corresponda legalmente.</li>
        </ul>
        <p style={styles.paragraph}>
          Las solicitudes podrán enviarse por correo electrónico a:{' '}
          <a href={`mailto:${DATOS_EMPRESA.email}`} style={styles.link}>{DATOS_EMPRESA.email}</a>
        </p>

        {/* Sección 9 */}
        <h2 style={styles.sectionTitle}>9. MODIFICACIONES</h2>
        <p style={styles.paragraph}>
          Páscolo podrá actualizar esta Política de Privacidad cuando resulte necesario. Las modificaciones serán publicadas en el Sitio y tendrán vigencia desde su publicación.
        </p>

        {/* Sección 10 */}
        <h2 style={styles.sectionTitle}>10. CONTACTO</h2>
        <p style={styles.paragraph}>
          Para consultas relacionadas con privacidad y protección de datos personales, puede escribirnos a:{' '}
          <a href={`mailto:${DATOS_EMPRESA.email}`} style={styles.link}>{DATOS_EMPRESA.email}</a>
        </p>

        {/* Botón de Retorno */}
        <div style={styles.footerAction}>
          <Link to="/" style={styles.btnPrimary}>Volver a la Tienda</Link>
        </div>

      </div>
    </div>
  );
};

// Estilos limpios y corporativos orientados a la lectura
const styles = {
  container: {
    display: 'flex',
    justifyContent: 'center',
    backgroundColor: '#f9fafb',
    padding: '40px 20px',
    minHeight: '100vh'
  },
  contentBox: {
    backgroundColor: '#ffffff',
    padding: '40px',
    borderRadius: '8px',
    boxShadow: '0 1px 3px 0 rgba(0, 0, 0, 0.1)',
    maxWidth: '800px',
    width: '100%',
    fontFamily: 'system-ui, -apple-system, sans-serif'
  },
  mainTitle: {
    fontSize: '28px',
    fontWeight: '700',
    color: '#111827',
    marginBottom: '8px',
    letterSpacing: '-0.5px'
  },
  date: {
    fontSize: '14px',
    color: '#6b7280',
    marginBottom: '20px'
  },
  divider: {
    border: '0',
    borderTop: '1px solid #e5e7eb',
    marginBottom: '24px'
  },
  sectionTitle: {
    fontSize: '18px',
    fontWeight: '600',
    color: '#111827',
    marginTop: '28px',
    marginBottom: '12px'
  },
  paragraph: {
    fontSize: '15px',
    color: '#374151',
    lineHeight: '1.6',
    marginBottom: '12px'
  },
  list: {
    fontSize: '15px',
    color: '#374151',
    lineHeight: '1.6',
    paddingLeft: '24px',
    marginBottom: '16px'
  },
  link: {
    color: '#000000',
    fontWeight: '500',
    textDecoration: 'underline'
  },
  footerAction: {
    marginTop: '40px',
    textAlign: 'center'
  },
  btnPrimary: {
    display: 'inline-block',
    backgroundColor: '#000000',
    color: '#ffffff',
    padding: '12px 24px',
    borderRadius: '6px',
    textDecoration: 'none',
    fontWeight: '600',
    fontSize: '14px'
  }
};

export default PoliticaDePrivacidad;